import { render, staticRenderFns } from "./BackSVG.vue?vue&type=template&id=dce03480&scoped=true&"
import script from "./BackSVG.vue?vue&type=script&lang=js&"
export * from "./BackSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce03480",
  null
  
)

export default component.exports